import { render } from "./loaderPOS.vue?vue&type=template&id=65466fe9&scoped=true"
const script = {}

import "./loaderPOS.vue?vue&type=style&index=0&id=65466fe9&lang=scss&scoped=true"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65466fe9"]])

export default __exports__